import { FormControl } from '@angular/forms';
import { SortDirection } from '@angular/material/sort';
import { Entity, Nullable } from '@pin-up-global/common';

export enum FlowsLocalEmpty {
  Missing = 'missing',
  Filled = 'filled',
}

export enum ReviewRequired {
  required = 'true',
  notRequired = 'false',
}

export enum SortByUpdate {
  newestFirst = 'desc',
  oldestFirst = 'asc',
  null = '',
}

export interface ReviewRequiredOption {
  value: Nullable<ReviewRequired>;
  label: string;
}

export interface SortByUpdateOption {
  value: Nullable<SortByUpdate>;
  label: string;
}

export interface FlowsLocalsReq {
  flowContentId?: number;
  limit?: number;
  page?: number;
  reviewRequired?: Nullable<boolean>;
  search?: Nullable<string>;
  sort?: string;
  sortType?: Nullable<SortDirection>;
}

export interface FlowContentItem  extends Entity {
  value: string;
  translations: FlowContentItemTranslation[];
  createdAt: string;
  updatedAt: string;
}

export interface FlowContentItemTable extends FlowContentItem {
  translationsObj: {
    [key: number]: FlowContentItemTranslation;
  };
}

export interface FlowContentItemTranslation extends Entity {
  value: string;
  localeId: number;
  reviewRequired: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface FlowContentItemTranslationStatistics {
  reviewRequiredCount: number;
  emptyValuesCount: number;
}

export type GetTranslationsStatisticsReq = Pick<FlowsLocalsReq, 'flowContentId'>;
export type PatchFlowContentReq = Pick<FlowContentItemTranslation, 'id' | 'value'>;

export interface FlowsLocalsFiltersForm {
  sort: FormControl<string>;
  sortType: FormControl<Nullable<SortDirection>>;
  search: FormControl<Nullable<string>>;
  reviewRequired: FormControl<Nullable<boolean>>;
}
